import { type ActivityContentObjectDetail, createActivityContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getActivity } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const useActivityQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<ActivityContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<ActivityContentObjectDetail>({
    async queryFn() {
      const { data } = await getActivity({ routeParams: { id } });
      return createActivityContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
